import instance from '../axios'

export type NotificationsSettings = {
  emailNotifications: boolean
  newEpisodeAlerts: boolean
  newSeasonAlerts: boolean
  recommendations: boolean
  newReleases: boolean
  commentReplies: boolean
  pushNotifications: boolean
  notificationFrequency: string
  quietHours: {
    enabled: boolean
    start: string
    end: string
  }
}

// A title showcased on top of the public profile (max 5).
export type PinnedMediaItem = {
  mediaType: 'Movie' | 'Show' | string
  tmdbId: number
  title: string
  posterPath?: string | null
  releaseYear?: number | null
}

export type SettingsResponse = {
  theme: string
  guideBannerDismissed: boolean
  onboardingCompleted: boolean
  profileVisibility: string
  rememberLastProfileTab: boolean
  preferredLanguage: string
  spoilerControl: boolean
  showProgressIndicators: boolean
  hideTmdbReviews: boolean
  browseHistoryEnabled: boolean
  keepLoggedIn: boolean
  region: string
  defaultLandingPage: string
  activityReminders: boolean
  recapAndMilestones: boolean
  notifications: NotificationsSettings
  pinnedMedia: PinnedMediaItem[]
}

export type SettingsRequest = Partial<SettingsResponse> & {
  notificationsAll?: boolean
}

export const settingsApi = {
  get: (token: string) =>
    instance.get<SettingsResponse>('/settings', {
      headers: { Authorization: `Bearer ${token}` },
    }),
  update: (token: string, body: SettingsRequest) =>
    instance.put<SettingsResponse>('/settings', body, {
      headers: { Authorization: `Bearer ${token}` },
    }),
}

export default settingsApi
